$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
Backbone = require 'backbone'
Data = require '../data'
{ defaults } = require 'lodash'
{ parse } = require '../../components/query-string'
{ getParams, getParam, addParam, deleteParam } = require './params'

module.exports =
class Mnue extends Singleton

  selector     : '.menu-contents'
  innerSelector: '.menu-contents-inner'
  imgSelector  : '.img-1'
  linkSelector : '.menu-list a'
  isOpenedClass: 'is-opened'
  isHoverClass : 'is-hover-menu-'
  bgClass      : 'bg'
  menuParam    : 'menu'

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'pagesLoaded': @onPagesLoaded
        'splashEnded': @onSplashEnded
    @$body  = Elements.$body
    @$btn   = Elements.$menuBtn
    @$menu  = $ @selector
    @$inner = @$menu.find @innerSelector
    @$img   = @$menu.find @imgSelector
    @$link  = @$menu.find @linkSelector
      .on
        'mouseover': @onLinkMouseover
        'mouseout' : @onLinkMouseout

    @hasPushState = window.history and history.pushState

    $.easeplus.addBackOut 'menuBackOut', 1
    $.easeplus.addBackIn 'menuBackIn', 1

  onPagesLoaded: =>
    @viewW   = @$window.width()
    @viewH   = @$body.height()
    @viewMax = Math.max @viewW, @viewH

    @$inner
      .prepend "<div class='#{@bgClass}'></div>"
    @$bg = @$inner.find ".#{@bgClass}"
    @setBgCss @viewMax

    @$inner
      .velocity
        translateX: '100%'
        translateY: '-100%'

  onSplashEnded: =>
    @$window.on 'resize', @onWindowResized
    @$btn.on 'click', @onBtnClicked

  onWindowResized: =>
    @viewW   = @$window.width()
    @viewH   = @$body.height()
    @viewMax = Math.max @viewW, @viewH
    @setBgCss @viewMax

  onBtnClicked: =>
    params = getParams()
    if getParam(@menuParam) is 'open'
      delete params[@menuParam]
    else
      params[@menuParam] = 'open'
    query    = $.param params
    pathname =
      if @hasPushState
        location.pathname
      else
        Data.directory[Data.location]
    fragment =
      if query then "#{pathname}?#{query}" else pathname
    Backbone.history.navigate fragment, true

  onLinkMouseover: (e) =>
    $el = $ e.currentTarget
    id  = $el.data 'menu-id'
    @$menu.addClass "#{@isHoverClass}#{id}"

  onLinkMouseout: (e) =>
    $el = $ e.currentTarget
    id  = $el.data 'menu-id'
    @$menu.removeClass "#{@isHoverClass}#{id}"

  open: =>
    addParam Data.location, @menuParam, 'open'
    @toggle [0, '100%'], [0, '-100%'], true

  close: =>
    deleteParam Data.location, @menuParam
    @toggle ['100%', 0], ['-100%', 0], false

  toggle: (posX, posY, toggle, opts = {}) ->
    opts = defaults opts,
      duration: 800

    if toggle
      opts.easing = 'menuBackOut'
      opts.begin  = =>
        @$menu.css 'display', 'block'
      @$btn.addClass @isOpenedClass
    else
      opts.easing   = 'menuBackIn'
      opts.complete = =>
        @$menu.css 'display', 'none'
      @$btn.removeClass @isOpenedClass

    @imgToggle toggle

    @$inner
      .velocity 'stop'
      .velocity
        translateX: posX
        translateY: posY
      , opts

  imgToggle: (toggle) ->
    if toggle
      opacity = 1
      display = 'block'
    else
      opacity = 0
      display = 'none'

    @$img
      .velocity 'stop'
      .velocity
        opacity: opacity
      ,
        duration: 200
        display : display

  setBgCss: (borderW) ->
    @$bg.css
      borderWidth: borderW * 2
      left       : -borderW * 2
      bottom     : -borderW * 2



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/menu.coffee